import {RouterModule, Routes } from '@angular/router';
import { HaMainComponentComponent } from './components/ha-main-component/ha-main-component.component';
import { HaDashboardComponentComponent } from './components/ha-dashboard-component/ha-dashboard-component.component';
import { HaNewUsermangementComponent } from './components/ha-new-usermangement/ha-new-usermangement.component';
import { HaPatientListComponent } from './components/ha-patient-list/ha-patient-list.component';
import { HaCaseListComponent } from './components/ha-case-list/ha-case-list.component';
import { HaScheduledPatientComponent } from './components/ha-scheduled-patient/ha-scheduled-patient.component';
import { HaSystemSettingComponent } from './components/ha-system-setting/ha-system-setting.component';
import { HaCreateRoleComponent } from './components/ha-create-role/ha-create-role.component';
import { HaTagSharingComponent } from './components/ha-tag-sharing/ha-tag-sharing.component';
import { HaTemplateSharingComponent } from './components/ha-template-sharing/ha-template-sharing.component';
import { HaCaseGroupCreationComponent } from './components/ha-case-group-creation/ha-case-group-creation.component';
import { HaCreatesurveyComponent } from './components/ha-createsurvey/ha-createsurvey.component';
import { HaNewcasegroupcreationComponent } from './components/ha-newcasegroupcreation/ha-newcasegroupcreation.component';
import { HaNewLicenseManagementComponent } from './components/ha-new-license-management/ha-new-license-management.component';
import { AuthguardGuard } from '../../core/guards/authguard.guard';
import { HaFeedbackComponent } from './components/ha-feedback/ha-feedback.component';
import { HaStarRatingComponent } from './components/ha-star-rating/ha-star-rating.component';
import { HaSurveymanagementCreateComponent } from './components/ha-surveymanagement-create/ha-surveymanagement-create.component';
import { HaSurveymainComponent } from './components/ha-surveymain/ha-surveymain.component';
import { HaSurveymanagementdisplayComponent } from './components/ha-surveymanagementdisplay/ha-surveymanagementdisplay.component';
import { HaCasecodecreationComponent } from './components/ha-casecodecreation/ha-casecodecreation.component';
import { TreeNodeeComponent } from './components/tree-nodee/tree-nodee.component';
import { HaCptUploadComponent } from './components/ha-cpt-upload/ha-cpt-upload.component';
import { HaTreeCptComponent } from './components/ha-tree-cpt/ha-tree-cpt.component';
import { HaHelpVideoComponent } from './components/ha-help-video/ha-help-video.component';
import { HaSharePatientComponent } from './components/ha-share-patient/ha-share-patient.component';
import { NgModule } from '@angular/core';





export const HaRoutes:Routes=[


  
    {
    path: 'HAAdmin',
    canActivate: [AuthguardGuard],
    data: { roles: ['HA','UHA'] },
        component: HaMainComponentComponent,
     
        children: [
         
          {
            path: 'dashboard',
            component: HaDashboardComponentComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA', 'UHA'] },
          },
          {
            path: 'UserManagement',
            component: HaNewUsermangementComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          {
            path: 'PatientLists',
            component: HaPatientListComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          {
            path: 'CaseLists',
            component: HaCaseListComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          {
            path: 'ScheduledPatient',
            component: HaScheduledPatientComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
         
         
          {
            path: 'SystemSetting',
            component: HaSystemSettingComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
         
        
          {
            path: 'CreateRole',
            component: HaCreateRoleComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          
          {
            path: 'TagSharing',
            component: HaTagSharingComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
    
          {
            path: 'TemplateSharing',
            component: HaTemplateSharingComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          {
            path: 'CaseGroupCreation',
            component: HaCaseGroupCreationComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA', 'UHA'] },
          },
    
          {
            path: 'CreateSurvey',
            component: HaCreatesurveyComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
    
    
         
       
          {
            path: 'HaCasegroupCreationCodes',
           
            component: HaNewcasegroupcreationComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA', 'UHA'] },
          },
        
          {
            path: 'HaFeedback',
            component: HaFeedbackComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          
          
          
    
          {
            path: 'HaLicense',
            component: HaNewLicenseManagementComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA', 'UHA'] },
          },
       
          {
            path: 'HaDashboard',
            component: HaDashboardComponentComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA', 'UHA'] },
          },
          {
            path: 'HaStarRating',
            component: HaStarRatingComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },

          {
            path: 'HaSurveymanagementCreate',
            component: HaSurveymanagementCreateComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          {
            path: 'HaSurveymain',
            component: HaSurveymainComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
         
          {
            path: 'HaCasecodecreation',
            component: HaCasecodecreationComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA', 'UHA'] },
          },
          {
            path: 'HaCptUpload',
            component: HaCptUploadComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          
          {
            path: 'TreeNodee',
            component: TreeNodeeComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          {
            path: 'TreeNodeeCpt',
            component: HaTreeCptComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
          {
            path: 'HaHelpVideo',
            component: HaHelpVideoComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA', 'UHA'] },
          },
     
          {
            path: 'HaSurveymanagementdisplay',
            component: HaSurveymanagementdisplayComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
         
          {
            path: 'HaSharePatient',
            component: HaSharePatientComponent,
            canActivate: [AuthguardGuard],
            data: { roles: ['HA'] },
          },
         
         
  
         
          
          {
            path: '',
            redirectTo:'dashboard',
            pathMatch:'full'
          }
        ]
      },
  ]
     

@NgModule({
imports:[RouterModule.forChild(HaRoutes)],
exports:[RouterModule]  
})



export class HAROUTINGMODULE{};
